import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import {
  FaBalanceScale,
  FaMoneyBillWave,
  FaUsersCog,
  FaGavel,
  FaLightbulb,
  FaChartLine,
  FaHandshake,
  FaShieldAlt,
  FaChartPie,
  FaCheckCircle,
  FaLeaf,
  FaBuilding,
} from "react-icons/fa";
import { motion } from "framer-motion";
import "bootstrap/dist/css/bootstrap.min.css";
import Header from "../components/Header";
import Footer from "../components/Footer";
import FAQ from "../components/Faq";
import BenefitsSection from "../components/BenefitsSection";

const Expertises = [
  {
    title: "Comptabilité - Fiscalité",
    subtitle:
      "Optimisez votre gestion financière et assurez votre conformité fiscale.",
    icon: <FaBalanceScale />,
    link: "/services/comptabilite-fiscalite",
    backgroundImage: "/assets/images/image7.png",
  },
  {
    title: "Audit",
    subtitle:
      "Expertise approfondie pour évaluer et améliorer la performance de votre entreprise.",
    icon: <FaChartPie />,
    link: "/services/audit",
    backgroundImage: "/assets/images/image-audit.png",
  },
  {
    title: "Contrôle de Gestion",
    subtitle:
      "Pilotage stratégique et optimisation de la performance financière.",
    icon: <FaCheckCircle />,
    link: "/services/controle-gestion",
    backgroundImage: "/assets/images/image-controle-gestion.png",
  },

  {
    title: "Consolidation des Comptes",
    subtitle:
      "Intégration et harmonisation de vos états financiers consolidés.",
    icon: <FaBalanceScale />,
    link: "/services/consolidation-comptes",
    backgroundImage: "/assets/images/image-consolidation.png",
  },
  {
    title: "Conseil et Stratégie d'Entreprise",
    subtitle:
      "Accompagnement stratégique pour la croissance et la transformation.",
    icon: <FaBuilding />,
    link: "/services/conseil-strategie-entreprise",
    backgroundImage: "/assets/images/image-conseil-strategie.png",
  },
  {
    title: "Corporate Finance",
    subtitle:
      "Solutions financières sur mesure pour vos projets de développement.",
    icon: <FaChartLine />,
    link: "/services/corporate-finance",
    backgroundImage: "/assets/images/image-corporate-finance.png",
  },
  {
    title: "RSE - Développement Durable",
    subtitle:
      "Intégration de la responsabilité sociale et environnementale dans votre stratégie.",
    icon: <FaLeaf />,
    link: "/services/rse-developpement-durable",
    backgroundImage: "/assets/images/image-rse.png",
  },
  {
    title: "Gestion du patrimoine",
    subtitle:
      "Accompagnement stratégique pour valoriser et protéger votre patrimoine.",
    icon: <FaMoneyBillWave />,
    link: "/services/gestion-patrimoine",
    backgroundImage: "/assets/images/image8.png",
  },
  {
    title: "Paie et gestion des salariés",
    subtitle:
      "Solutions complètes pour gérer la paie et vos ressources humaines.",
    icon: <FaUsersCog />,
    link: "/services/paie-gestion-salaries",
    backgroundImage: "/assets/images/image9.png",
  },
  {
    title: "Droit des affaires et contentieux",
    subtitle:
      "Expertise juridique pour sécuriser vos opérations et résoudre les litiges.",
    icon: <FaGavel />,
    link: "/services/droit-affaires-contentieux",
    backgroundImage: "/assets/images/image10.png",
  },
  {
    title: "Accompagnement à la création et à la transformation d'entreprise",
    subtitle:
      "Assistance pour démarrer et faire évoluer votre entreprise en toute sécurité.",
    icon: <FaLightbulb />,
    link: "/services/creation-transformation-entreprise",
    backgroundImage: "/assets/images/image11.png",
  },
  {
    title: "Montage de projets et business plan",
    subtitle:
      "Structurer et piloter vos projets pour maximiser vos chances de succès.",
    icon: <FaChartLine />,
    link: "/services/montage-projets-business-plan",
    backgroundImage: "/assets/images/image12.png",
  },
  {
    title: "Conseils et accompagnement juridique",
    subtitle:
      "Expertise en droit des entreprises pour garantir votre conformité.",
    icon: <FaHandshake />,
    link: "/services/conseils-accompagnement-juridique",
    backgroundImage: "/assets/images/image13-1.png",
  },
  {
    title: "Solutions informatiques et de sécurité",
    subtitle:
      "Protégez et optimisez votre infrastructure informatique avec nos solutions.",
    icon: <FaShieldAlt />,
    link: "/services/solutions-informatiques-securite",
    backgroundImage: "/assets/images/image14.png",
  },
  {
    title: "Banques Finances et Assurances",
    subtitle:
      "Notre Expertise au Service du Secteur Banque, Finance et Assurance.",
    icon: <FaShieldAlt />,
    link: "/services/banques-finances",
    backgroundImage: "/assets/images/image28.png",
  },
];

const Services = () => {
  useEffect(() => {
    const sections = document.querySelectorAll(".animate-on-scroll");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("animate");
          }
        });
      },
      { threshold: 0.2 }
    );

    sections.forEach((section) => {
      observer.observe(section);
    });

    return () => {
      sections.forEach((section) => {
        observer.unobserve(section);
      });
    };
  }, []);

  return (
    <>
      <Header />

      <div className="services-banner animate-on-scroll d-flex align-items-center">
        <div className="container text-white text-start">
          <h1 className="fw-bold display-4">Nos Expertises</h1>
          <p className="lead">
            Solutions complètes pour le développement et la performance de votre
            entreprise.
          </p>
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to="/" className="text-white text-decoration-none">
                  Accueil
                </Link>
              </li>
              <li
                className="breadcrumb-item active text-white"
                aria-current="page"
              >
                Expertises
              </li>
            </ol>
          </nav>
        </div>
      </div>


      <div>
        <motion.h2
          className="section-title"
          initial={{ opacity: 0, y: -30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
        >
          Découvrez <span className="highlight">Nos Expertises</span>
        </motion.h2>
      </div>


      <section className="service-section">
        <div className="container">
          <div className="row">
            {Expertises.map((expertise, index) => (
              <motion.div
                key={index}
                className="col-md-6 col-lg-3 service-container"
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.2 }}
              >
                <Link
                  to={expertise.link}
                  className="service-card"
                  style={{
                    backgroundImage: `url(${expertise.backgroundImage})`,
                  }}
                >
                  <div className="overlay"></div>
                  <div className="darken"></div>

                  <div className="content">
                    <div className="icon-container">{expertise.icon}</div>
                    <h3 className="card-title">{expertise.title}</h3>
                    <p className="card-subtitle">{expertise.subtitle}</p>
                  </div>
                </Link>
              </motion.div>
            ))}
          </div>
        </div>

        <style>
          {`
          .services-banner {
            position: relative;
            background: linear-gradient(to right, rgba(255, 0, 0, 0.7), rgba(0, 150, 0, 0.7)), 
                        url("../assets/images/image14.png");
            background-size: cover;
            background-position: center;
            height: 400px;
            display: flex;
            align-items: center;
            color: white;
            opacity: 0;
            transform: translateY(50px);
            transition: opacity 0.8s ease-out, transform 0.8s ease-out;
          }

          .service-section {
            padding: 100px 20px 60px; /* Augmenté le padding en haut */
            text-align: center;
            background-color: #f8f9fa;
          }

          .section-title {
            font-size: 34px;
            font-weight: bold;
            margin-bottom: 40px;
          }

          .highlight {
            color: #dc3545;
          }

          .breadcrumb {
            background: transparent;
            font-size: 18px;
            padding: 0;
          }

          .breadcrumb-item a {
            color: white;
            font-weight: 500;
          }

          .breadcrumb-item.active {
            font-weight: bold;
          }

          .service-container {
            margin-bottom: 40px; /* Espace entre les cartes */
          }

          .service-card {
            position: relative;
            height: 350px;
            border-radius: 0;
            overflow: hidden;
            background-size: cover;
            background-position: center;
            display: flex;
            align-items: flex-end;
            text-align: left;
            padding: 20px;
            text-decoration: none;
            color: white;
            transition: transform 0.3s ease-in-out;
          }

          .service-card:hover {
            transform: scale(1.05);
          }

          .service-card .darken {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, 0.3);
          }

          .service-card .overlay {
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
            height: 0%;
            background: linear-gradient(to top, rgba(255, 0, 0, 0.4), rgba(0, 255, 0, 0.4));
            transition: height 0.4s ease-in-out;
          }

          .service-card:hover .overlay {
            height: 100%;
          }

          .service-card .content {
            position: relative;
            z-index: 2;
          }

          .icon-container {
            font-size: 48px;
            margin-bottom: 15px;
            color: #ffc107;
          }

          .card-title {
            font-size: 20px;
            font-weight: bold;
            margin-bottom: 10px;
          }

          .card-subtitle {
            font-size: 14px;
            margin-top: 5px;
            opacity: 0;
            transform: translateY(10px);
            transition: opacity 0.4s ease-in-out, transform 0.4s ease-in-out;
          }

          .service-card:hover .card-subtitle {
            opacity: 1;
            transform: translateY(0);
          }

          .animate {
            opacity: 1 !important;
            transform: translateY(0) !important;
          }

          @media (max-width: 768px) {
            .services-banner {
              height: 300px;
            }

            .service-section {
              padding: 120px 20px 40px; /* Plus de marge sur mobile */
            }

            .service-container {
              margin-bottom: 20px; /* Réduction de l'espace sur mobile */
            }
          }
        `}
        </style>
      </section>

      <FAQ />
      <BenefitsSection />
      <Footer />
    </>
  );
};

export default Services;
